const { stringify } = require('../helpers');

let bridge = {
    output: () => {
        console.error(Error('Bridge Logging is enabled but no implementation is provided'));
        //only error once:
        bridge.output = () => {};
    }
};
/**
 * You can create a device specific outputType by using
 * `setOutputType(logging.outputType.BRIDGE)` and `setBridgeLogger(bridgeImplementation)`.
 * In this case, `bridgeImplementation` must implement
 * the `output(message, logLevel)` method which sends the message to the device specific log
 * (such as Android logcat) using the appropriate methods.
 * @param {object[]} message(s)
 * @param {object} [userContext]
 * @param {LogLevel} logLevel Level to log message with
 */
function output(message, userContext, logLevel) {
    bridge.output(message.map(m => stringify(m)).join(' '), logLevel);
}

/**
 * Assign Bridge Logging implementation
 * @param {*} bridgeImplementation device specific outputType
 * @param {function} bridgeImplementation.output method receiving `(message, logLevel)` which should send the message to the device specific log (such as Android logcat) using the appropriate methods.
 */
function setBridgeLogger(bridgeImplementation) {
    if (!bridgeImplementation.output) {
        console.error(Error('BridgeImplementation does not contain an ".output()" method'));
        return;
    }
    bridge = bridgeImplementation;
}

module.exports = {
    output,
    setBridgeLogger
};
